import React from "react";
import { Routes, Route } from "react-router";
import AuditLog from "./AuditLog";

const AuditLogRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AuditLog />} />
    </Routes>
  );
};

export default AuditLogRoutes;
